class RecentlyViewedStorage {
    constructor(maxProducts = 10) {
        this.storageKey = 'recently_viewed_products';
        this.maxProducts = maxProducts;
    }

    get() {
        try {
            return JSON.parse(localStorage.getItem(this.storageKey)) || [];
        } catch {
            return [];
        }
    }

    save(products) {
        localStorage.setItem(
            this.storageKey,
            JSON.stringify(products)
        );
    }

    add(product) {
        if (!product?.id) return;

        let products = this.get();

        // Remove duplicate
        products = products.filter(p => p.id !== product.id);

        // Add newest to front
        products.unshift(product);

        // Limit max products
        products = products.slice(0, this.maxProducts);

        this.save(products);
    }

    remove(productId) {
        const products = this
            .get()
            .filter(p => p.id !== productId);

        this.save(products);
    }

    clear() {
        localStorage.removeItem(this.storageKey);
    }
}

window.RecentlyViewedStorage = new RecentlyViewedStorage(10);